import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner'
import I18n from '../../resources/i18n/I18n'
import CustomButton from 'components/buttons/CustomButton'

const ValidationEventsModal = ({ showModal, onHideModal, loading, onValidateModal }) => {
  return (
    <Modal className="modal" show={showModal} onHide={onHideModal}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('ValidationEventsTitle')}</Modal.Title>
      </Modal.Header>

      <Modal.Body className="d-flex justify-content-center align-items-center">
        {loading ? (
          <Spinner animation="border" variant="primary" />
        ) : (
          <div className="d-flex flex-column align-items-center gap-y-4">
            <p>{I18n.t('ValidationEventsDescription')}</p>
            <div className="d-flex align-items-center justify-content-center gap-x-2">
              <CustomButton onClick={onValidateModal} small primary title={I18n.t('Yes')} />
              <CustomButton onClick={onHideModal} small secondary title={I18n.t('No')} />
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ValidationEventsModal
